import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { createDashboardModel } from 'models/dashboard';
import { useAuth } from 'services/authentication';
import ManageDashboard from 'components/ManageDashboard';

export default function CreateDashboard() {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user.permissions.role !== 'admin') {
            navigate('/');
        }
    }, [user]);

    const dashboard = createDashboardModel();

    return (
        <div data-testid="route-dashboards-create">
            <ManageDashboard dashboard={dashboard} action={'create'} />
        </div>
    );
}
